<template>
  <section class="batches-list-view">
    <batches-list-skeleton v-if="batchesLoading" />

    <div
      v-else
      class="print-tag-batches"
    >
      <transition
        v-if="hasBatches"
        name="fade"
        mode="out-in"
      >
        <div class="batches-list-sections">
          <section
            v-if="hasUnprintedBatches"
            class="batches-list-grid print-tag-batches__card-container"
          >
            <div
              v-for="(batch, index) in unprintedBatches"
              :key="index"
              :md-item="unprintedBatches"
              class="card-box"
              :class="{
                'collapsed': batch.expanded
              }"
            >
              <batch-card
                :index="index"
                :batch="batch"
              />
            </div>
          </section>

          <section
            v-if="hasPrintedBatches"
            class="print-tag-batches__card-container"
          >
            <header class="batches-list-section-header">
              <h3 class="batches-list-section-title">
                Impressos
              </h3>
            </header>

            <div class="batches-list-grid">
              <div
                v-for="(batch, index) in printedBatches"
                :key="index"
                :md-item="printedBatches"
                class="card-box-printed"
              >
                <batch-card
                  :index="index"
                  :batch="batch"
                />
              </div>
            </div>
          </section>
        </div>
      </transition>

      <empty-cart
        v-else
        class="batches-list-empty-state"
        description="Não existem lotes disponíveis de acordo com a busca realizada."
        img="/static/images/icon-lotes-nao-cadastrados.svg"
      />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BatchCard from '@/components/PrintLabels/Batches/Cards/BatchCard'
import BatchesListSkeleton from '@/components/PrintLabels/Batches/BatchesListSkeleton'
import EmptyCart from '@/components/common/EmptyCart'
import mixin from '@/components/PrintLabels/Batches/BatchesMixin'
import notify from '@/api/notification'

export default {
  name: 'BatchesList',
  components: {
    BatchCard,
    BatchesListSkeleton,
    EmptyCart,
  },
  mixins: [mixin],
  computed: {
    ...mapGetters([
      'batchesLoading',
      'batchesLoadingStatus',
      'printedBatches',
      'unprintedBatches'
    ]),
    hasPrintedBatches() {
      return !!this.printedBatches?.length
    },
    hasUnprintedBatches() {
      return !!this.unprintedBatches?.length
    },
    hasBatches() {
      return this.hasPrintedBatches || this.hasUnprintedBatches
    },
    batchesAmount() {
      return this.printedBatches.length + this.unprintedBatches.length
    }
  },
  watch: {
    batchesLoadingStatus(newValue) {
      if (newValue === 'STATUS_FAILED') {
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: this.handleReload
          }
        })
      }
    }
  },
  beforeDestroy() {
    this.clearAllBatchesData()
  },
  methods: {
    ...mapActions([
      'clearAllBatchesData',
    ]),
    handleReload() {
      window.location.reload()
    },
  }
}
</script>

<style lang="scss" scoped>
  @use '@/../static/stylesheets/variables' as *;

  .batches-list {
    &-sections {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }

    &-section {
      &-header {
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid #818181;
      }

      &-title {
        font-size: 1rem;
        font-weight: 500;
        color: #818181;
      }
    }

    &-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax($batch-card-min-w, 1fr));
      gap: 1rem;

      .batch-card {
        height: 100%;
      }
    }

    &-empty-state {
      height: max-content;
    }
  }
</style>
